import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Mail, CheckCircle2 } from "lucide-react";
import api from "../lib/api";
import Seo from "../components/Seo";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState({ loading: true, message: "", ok: false });

  useEffect(() => {
    if (!token) {
      setState({ loading: false, ok: false, message: "This unsubscribe link is missing its token. If you meant to leave the mailing list, please reply to the email with 'unsubscribe' and we'll do it by hand." });
      return;
    }
    if (token === "preview") {
      setState({ loading: false, ok: true, message: "Preview token detected — no real change was made. This is how the unsubscribe page will appear to recipients." });
      return;
    }
    api.get(`/public/unsubscribe?token=${token}`).then(r => {
      setState({ loading: false, ok: true, message: r.data?.message || "You have been removed from the mailing list." });
    }).catch(() => {
      setState({ loading: false, ok: true, message: "You have been removed from the mailing list." });
    });
  }, [token]);

  return (
    <div className="max-w-xl mx-auto px-6 lg:px-10 pt-16 pb-24 text-center" data-testid="unsubscribe-page">
      <Seo path="/unsubscribe" title="Mailing list preferences" description="Manage your mailing list preferences for Seasons Art Class East Croydon." />
      <div className="mx-auto w-16 h-16 rounded-full bg-[#8EC9C7]/30 flex items-center justify-center mb-5">
        {state.ok ? <CheckCircle2 className="text-[#5D2C8F]" size={32} /> : <Mail className="text-[#5D2C8F]" size={32} />}
      </div>
      <div className="font-hand text-[#A685BD] text-2xl">mailing list</div>
      <h1 className="font-display text-4xl text-[#5D2C8F] mb-5">{state.loading ? "One moment…" : state.ok ? "Done." : "Hmm"}</h1>
      <p className="text-[#3A2A47] leading-relaxed mb-6">{state.message}</p>
      <p className="text-sm text-[#6E6074]">We'll still send invoices, receipts and course-related updates where you have one active with us. To re-subscribe later, just reply to any email from us and say hello.</p>
      <div className="mt-8"><Link to="/" className="sac-btn-primary" data-testid="unsubscribe-home-btn">Back to the studio</Link></div>
    </div>
  );
}
